import { render, staticRenderFns } from "./atcclswipe.vue?vue&type=template&id=4ea35c4a&scoped=true&"
import script from "./atcclswipe.vue?vue&type=script&lang=js&"
export * from "./atcclswipe.vue?vue&type=script&lang=js&"
import style0 from "./atcclswipe.vue?vue&type=style&index=0&id=4ea35c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea35c4a",
  null
  
)

export default component.exports